import 'twin.macro';
import 'styled-components/macro';
import { FC } from 'react';

import { useFavoritesContext } from 'toy/context/Favorites';

import { FavoritesToggle } from '../../atoms/favorites-toggle/FavoritesToggle';

export const SmartFavoritiesToggle: FC<{ id: string }> = ({ id }) => {
  const { items, addItem, removeItem } = useFavoritesContext();
  const isInFavorites = items.includes(id);

  return (
    <FavoritesToggle isInFavorites={isInFavorites} onClick={() => (isInFavorites ? removeItem(id) : addItem(id))} />
  );
};
